import { getShortDate } from '../../Utils/UtilFunctions';
import {
  CARAT_DATA,
  GOLD_DATA,
  GRAM_WISE_CARAT_RATE,
  HISTORICAL_DATA,
  HISTORICAL_DATA_SILVER,
  MONTH_WISE_DATA,
  MONTH_WISE_DATA_SILVER,
  SILVER_DATA,
} from './types';

export const capitalized = (word: string): string =>
  word.charAt(0).toUpperCase() + word.slice(1);

export enum SIGN {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  ZERO = 'zero',
}
export const checkNumberSign = (value: number): string => {
  if (value > 0) return SIGN.POSITIVE;
  if (value < 0) return SIGN.NEGATIVE;
  return SIGN.ZERO;
};

export const sanitizeCityName = (cityName: string): string => {
  // Remove any non-alphanumeric characters
  cityName = cityName.replace(/[^\w-]/g, '');
  cityName = cityName.trim();
  cityName = cityName.substring(0, 50);
  return cityName;
};

export const getFormattedHistoricalData = (
  data: MONTH_WISE_DATA[]
): HISTORICAL_DATA[] => {
  const myFinalArray: HISTORICAL_DATA[] = [];
  data?.map((item) => {
    myFinalArray.push({
      goldRateOn: `Gold Price Movement ${item.monthName} ${item.year}`,
      subRows: [
        {
          goldRateOn: getShortDate(item.startDate.date),
          carat22: `₹${item.startDate.carat22.ratePerGram * 10}`,
          carat24: `₹${item.startDate.carat24.ratePerGram * 10}`,
        },
        {
          goldRateOn: getShortDate(item.endDate.date),
          carat22: `₹${item.endDate.carat22.ratePerGram * 10}`,
          carat24: `₹${item.endDate.carat24.ratePerGram * 10}`,
        },
        {
          goldRateOn: `Highest rate in ${item.monthName}`,
          carat22: `₹${item.highestRate.carat22.ratePerGram * 10}`,
          carat24: `₹${item.highestRate.carat24.ratePerGram * 10}`,
        },
        {
          goldRateOn: `Lowest rate in ${item.monthName}`,
          carat22: `₹${item.lowestRate.carat22.ratePerGram * 10}`,
          carat24: `₹${item.lowestRate.carat24.ratePerGram * 10}`,
        },
        {
          goldRateOn: 'Overall Performance',
          carat22: `₹${item.overallPerformance.carat22 * 10}`,
          carat24: `₹${item.overallPerformance.carat24 * 10}`,
        },
        {
          goldRateOn: 'Change',
          carat22: `${(Number(item.change.carat22) * 10).toFixed(2)}%`,
          carat24: `${(Number(item.change.carat24) * 10).toFixed(2)}%`,
        },
      ],
    });
  });
  return myFinalArray;
};

export const getFormattedSilverHistoricalData = (
  data: MONTH_WISE_DATA_SILVER[]
): HISTORICAL_DATA_SILVER[] => {
  const myFinalArray: HISTORICAL_DATA_SILVER[] = [];
  data?.map((item) => {
    myFinalArray.push({
      goldRateOn: `Silver Price Movement ${item.monthName} ${item.year}`,
      subRows: [
        {
          goldRateOn: getShortDate(item.startDate.date),
          ratePerGram: `₹${item.startDate.ratePerGram * 10}`,
          ratePerKg: `₹${item.startDate.ratePerGram * 1000}`,
        },
        {
          goldRateOn: getShortDate(item.endDate.date),
          ratePerGram: `₹${item.endDate.ratePerGram * 10}`,
          ratePerKg: `₹${item.endDate.ratePerGram * 1000}`,
        },
        {
          goldRateOn: `Highest rate in ${item.monthName}`,
          ratePerGram: `₹${item.highestRate.ratePerGram * 10}`,
          ratePerKg: `₹${item.highestRate.ratePerGram * 1000}`,
        },
        {
          goldRateOn: `Lowest rate in ${item.monthName}`,
          ratePerGram: `₹${item.lowestRate.ratePerGram * 10}`,
          ratePerKg: `₹${item.lowestRate.ratePerGram * 1000}`,
        },
        {
          goldRateOn: 'Overall Performance',
          ratePerGram: `₹${item.overallPerformance * 10}`,
          ratePerKg: `₹${item.overallPerformance * 1000}`,
        },
        {
          goldRateOn: 'Change',
          ratePerGram: `${(Number(item.change) * 10).toFixed(2)}%`,
          ratePerKg: `${(Number(item.change) * 1000).toFixed(2)}%`,
        },
      ],
    });
  });
  return myFinalArray;
};

export const getGramWiseGoldData = (
  data: GOLD_DATA
): GRAM_WISE_CARAT_RATE[] => {
  return [
    {
      carat: '24 carat',
      rate: data.carat24.ratePerGram,
      change: data.carat24.change,
    },
    {
      carat: '22 carat',
      rate: data.carat22.ratePerGram,
      change: data.carat22.change,
    },
  ];
};

export const getGramWiseSilverData = (data: SILVER_DATA): CARAT_DATA[] => {
  return [
    {
      ratePerGram: data.ratePerGram,
      change: data.change,
    },
  ];
};

export const getMetalData = async (URLArrays: Array<string>) => {
  const array = await Promise.all(URLArrays.map((url) => fetch(url)));
  return await Promise.all(array.map((res) => res.json()));
};
